import React, { useEffect, useImperativeHandle, useRef } from "react";
import {
  Accordion,
  Alert,
  Box,
  Checkbox,
  CircularProgress,
  DialogProps,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  Link as LinkReact,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
  useTheme,
} from "@mui/material";
import { set } from "../../../../app/globalSlice";
import { requestApi } from "../../../../helpers/RequestApi";
import { GET, POST } from "../../../../utils/MethodUtils";
import { FARTICLE_URL, FDOCENTETES_URL } from "../../../../utils/UrlsUtils";
import { toastr } from "react-redux-toastr";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { RootState } from "../../../../app/store";
import { useTranslation } from "react-i18next";
import {
  FArtfournissFArticleInterface,
  FArticleSmallInterface,
  FArtstockInterface,
} from "../../../../interfaces/FArticleInterface";
import SearchComponent from "../../SearchComponent";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import CopyClipboardComponent from "../../CopyClipboardComponent";
import { DEFAULT_DEPOT } from "../../../../utils/FArticleUtils";
import { FArticleFournisseurStockComponent } from "../../fArticle/FArticleFournisseursComponent";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import FormControlLabel from "@mui/material/FormControlLabel";
import { PRODUCT_PAGE } from "../../../../utils/RouteUtils";
import { Link } from "react-router-dom";
import { priceFormat } from "../../../../utils/FormatUtils";
import { SUPPLIER_MC3 } from "../../../../utils/UserUtils";
import { InputInterface } from "../../../../interfaces/InputInterface";
import { LoadingButton } from "@mui/lab";
import getErrorApi from "../../../../helpers/GetErrorApi";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { getUrlFArticleImage } from "../../../../helpers/FileHelper";
import { IMAGE_SIZE_LOGO } from "../../../../utils/FileUtils";
import Badge from "@mui/material/Badge";
import {
  CONDITION_AND,
  CONDITION_OR,
  CONDITIONS_FILTER,
} from "../../../../utils/FilterUtils";
import MenuItem from "@mui/material/MenuItem";
import { SelectChangeEvent } from "@mui/material/Select";
import { FOURNISSEUR_STOCK_STATUS_IN_STOCK } from "../../../../utils/NoveFournisseurUtils";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { getUrlsFournisseur } from "../../../../helpers/FArticleHelper";
import LinkIcon from "@mui/icons-material/Link";
import FactoryIcon from "@mui/icons-material/Factory";
import CloseIcon from "@mui/icons-material/Close";
import Chart from "react-apexcharts";
import { useInView } from "react-intersection-observer";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}, &.${tableCellClasses.footer}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&`]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

interface State {
  fArticle: FArticleSmallInterface;
  odd: boolean;
  last: boolean;
  index: number;
}

interface State2 {
  initQuantity: number;
  updateNewTerme: Function;
  fArtfournis: FArtfournissFArticleInterface;
}

interface State3 {
  fArticle: FArticleSmallInterface;
  fArtfournis: FArticleToShowFArtfournissInterface;
  showFournisseur: boolean;
  odd: boolean;
  indexFArtfourniss: number;
  switchShowFournisseur: Function;
  updateNewTerme: Function;
  nbFournisseurInStock: number;
  setParentFArtfourniss: Function;
}

interface State4 {
  willCreate: WillCreateInterface;
  index: number;
}

interface State5 {
  fArticle: FArticleSmallInterface;
}

interface State6 {
  prop: "afQtemini" | "afColisage";
  value: string | number;
  setEdit: Function;
  setValue: Function;
  arRef: string;
  ctNum: string;
}

interface FArticleToShowInterface {
  fArticle: FArticleSmallInterface;
  ref: any;
}

interface FormState {
  quantity: InputInterface;
}

interface FormState4 {
  afQtemini?: InputInterface;
  afColisage?: InputInterface;
}

interface FormState2 {
  showOnlyTerme: InputInterface;
  fournisseur: InputInterface;
  fournisseurOrAnd: InputInterface;
  fournisseurPrincipal: InputInterface;
}

interface FormState3 {
  reference: InputInterface;
}

interface WillCreateInterface {
  ctNum: string;
  nbFArticle: number;
  ref: any;
}

const ChartComponent = React.memo(
  React.forwardRef(({ fArticle }: State5, ref2) => {
    const { ref, inView } = useInView({
      triggerOnce: true, // Load only once
      threshold: 0.1, // 10% visibility
    });

    const rawData = fArticle.statistiqueVentes!;

    let asQtesto = Number(
      fArticle.fArtstocks.find((f) => f.fDepot.deNo === DEFAULT_DEPOT)
        ?.asQtesto ?? 0
    );
    // Generate the last 12 months from today
    const today = new Date();
    const months: { key: string; label: string }[] = [];
    for (let i = 12; i >= 0; i--) {
      const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      months.push({
        key: `${year}-${String(month).padStart(2, "0")}`,
        label: `${String(month).padStart(2, "0")}/${year}`,
      });
    }

    // Map raw data to a dictionary for quick lookup
    const dataMap = new Map(
      rawData.map((d) => [`${d.Annee}-${String(d.Mois).padStart(2, "0")}`, d])
    );

    // Prepare series data with gaps as nulls
    const venteSeries = months.map((m) =>
      dataMap.has(m.key) ? dataMap.get(m.key)?.QteCumVente ?? null : null
    );
    const achatSeries = months.map((m) =>
      dataMap.has(m.key) ? dataMap.get(m.key)?.QteCumAchat ?? null : null
    );
    const stockSeries = [];
    for (let i = 12; i >= 0; i--) {
      asQtesto += venteSeries[i] ?? 0;
      asQtesto -= achatSeries[i] ?? 0;
      stockSeries.push(asQtesto);
    }
    stockSeries.reverse();

    const series = [
      {
        name: "Ventes",
        data: venteSeries,
        type: "column",
      },
      {
        name: "Achats",
        data: achatSeries,
        type: "column",
      },
      {
        name: "Stock",
        data: stockSeries,
        type: "line", // Line chart overlaid on the bars
      },
    ];

    const yMax =
      Math.ceil(
        Math.max(
          // @ts-ignore
          ...venteSeries
            .concat(achatSeries)
            .concat(stockSeries)
            .filter((x) => x !== null)
        ) / 5
      ) * 5;

    const customLines = Array.from({ length: yMax / 5 + 1 }, (_, i) => i * 5)
      .filter((val) => val !== 0) // on laisse Apex gérer la ligne de base à 0
      .map((val) => {
        const r: YAxisAnnotations = {
          y: val,
          borderColor: "#cccccc",
          strokeDashArray: 4,
        };
        return r;
      });

    return (
      <Box ref={ref} style={{ minHeight: 350 }}>
        {inView && (
          <Chart
            options={{
              chart: {
                type: "bar",
                height: 350,
              },
              grid: {
                show: false, // on cache la grille régulière
              },
              colors: ["#28a745", "#dc3545", "#007bff"], // Green, Red, Blue
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "50%",
                },
              },
              dataLabels: {
                enabled: false,
              },
              stroke: {
                show: true,
                width: [2, 2, 3], // Slightly thicker for stock line
                colors: ["transparent", "transparent", "#007bff"],
              },
              xaxis: {
                categories: months.map((m) => m.label),
              },
              annotations: {
                yaxis: customLines,
              },
              yaxis: {
                min: 0,
                max: yMax,
                tickAmount: yMax / 5,
                labels: {
                  formatter: (val) => Math.round(val).toString(),
                },
                title: {
                  text: "Quantité",
                },
              },
              fill: {
                opacity: 1,
              },
              tooltip: {
                shared: true,
                intersect: false,
                y: {
                  formatter: (val: number | null) =>
                    val !== null ? `${Math.round(val)} unités` : "0",
                },
              },
            }}
            series={series}
            type="bar"
            height={350}
          />
        )}
      </Box>
    );
  })
);

const UpdateFArtfounissPropComponent = React.memo(
  React.forwardRef(
    ({ prop, value, setEdit, arRef, ctNum, setValue }: State6, ref) => {
      const { t } = useTranslation();
      const [loading, setLoading] = React.useState<boolean>(false);
      const token = useAppSelector(
        (state: RootState) => state.globalState.token
      );
      const handleChange = React.useCallback(
        (prop: keyof FormState4) =>
          (event: React.ChangeEvent<HTMLInputElement>) => {
            let value = event.target.value;
            if (Number(value) < 0) {
              value = "0";
            }
            setValues((v) => {
              return {
                ...v,
                [prop]: { ...v[prop], value: value, error: "" },
              };
            });
          },
        []
      );
      const getDefaultValue = React.useCallback((): FormState4 => {
        return {
          [prop]: {
            value: value,
            error: "",
          },
        };
      }, [prop, value]);
      const [values, setValues] = React.useState<FormState4>(getDefaultValue());
      const save = React.useCallback(async () => {
        setLoading(true);
        const response = await requestApi({
          method: POST,
          path: FARTICLE_URL + "/" + arRef + "/fartfourniss/" + ctNum,
          allowError: true,
          token: token,
          body: {
            prop: prop,
            value: values[prop]?.value,
          },
        });
        if (response.statusCode === 200) {
          setEdit(false);
          setValue(Number(values[prop]?.value));
        } else if (response.statusCode === 401) {
          toastr.info(t("word.info"), t("error.reconnect"));
        } else {
          toastr.error(t("word.error"), t("error.tryAgain"));
        }
        setLoading(false);
      }, [arRef, ctNum, prop, setEdit, setValue, t, token, values]);

      const addQuantity = React.useCallback(() => {
        setValues((v) => {
          let value = Number(v[prop]?.value) + 1;
          return {
            ...v,
            [prop]: {
              ...v[prop],
              value: value.toString(),
              error: "",
            },
          };
        });
      }, [prop]);

      const removeQuantity = React.useCallback(() => {
        setValues((v) => {
          let newQuantity = Number(v[prop]?.value) - 1;
          if (newQuantity < 0) {
            newQuantity = 0;
          }
          return {
            ...v,
            [prop]: {
              ...v[prop],
              value: newQuantity.toString(),
              error: "",
            },
          };
        });
      }, [prop]);

      useEffect(() => {
        setValues(getDefaultValue());
      }, [prop, value]); // eslint-disable-line react-hooks/exhaustive-deps

      let nbChar = values[prop]?.value.toString().length;
      if (nbChar < 2) {
        nbChar = 2;
      }
      return (
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
          <FormControl variant="outlined" required sx={{ marginBottom: 2 }}>
            <InputLabel>{t("field." + prop)}</InputLabel>
            <OutlinedInput
              type="number"
              className="center-input"
              value={values[prop]!.value}
              onChange={handleChange(prop)}
              inputProps={{
                sx: {
                  width: nbChar * 9,
                },
              }}
              label={t("field." + prop)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label={t("field.action.add_quantity")}
                    onClick={addQuantity}
                    edge="end"
                  >
                    <AddIcon />
                  </IconButton>
                </InputAdornment>
              }
              startAdornment={
                <InputAdornment position="start">
                  <IconButton
                    aria-label={t("field.action.remove_quantity")}
                    onClick={removeQuantity}
                    edge="end"
                  >
                    <RemoveIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <Box>
            <Tooltip title={t("word.cancel")}>
              <IconButton
                disabled={loading}
                onClick={() => {
                  setEdit(false);
                }}
              >
                <CancelIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("word.save")}>
              <LoadingButton
                variant="text"
                color="inherit"
                sx={{
                  borderRadius: "50%",
                  minWidth: "auto",
                  padding: "8px",
                  color: "rgba(0, 0, 0, 0.54)",
                }}
                loading={loading}
                onClick={save}
              >
                <SaveIcon />
              </LoadingButton>
            </Tooltip>
          </Box>
        </Box>
      );
    }
  )
);

const ReapproSingleArticleInputComponent = React.memo(
  React.forwardRef(
    ({ initQuantity, updateNewTerme, fArtfournis }: State2, ref) => {
      const { t } = useTranslation();
      const handleChange = React.useCallback(
        (prop: keyof FormState) =>
          (event: React.ChangeEvent<HTMLInputElement>) => {
            let value = event.target.value;
            if (Number(value) < 0) {
              value = "0";
            }
            setValues((v) => {
              return {
                ...v,
                [prop]: { ...v[prop], value: value, error: "" },
              };
            });
          },
        []
      );
      const getDefaultValue = React.useCallback((): FormState => {
        return {
          quantity: {
            value: initQuantity.toString(),
            error: "",
          },
        };
      }, [initQuantity]);
      const [values, setValues] = React.useState<FormState>(getDefaultValue());
      const [editQec, setEditQec] = React.useState<boolean>(false);
      const [editColisage, setEditColisage] = React.useState<boolean>(false);

      const modulo = React.useCallback((m: number) => {
        if (m === 0) {
          return;
        }
        setValues((v) => {
          const currentValue = Number(v.quantity.value);
          const newValue = (Math.ceil(currentValue / m) * m).toString();
          return {
            ...v,
            quantity: {
              ...v.quantity,
              value: newValue,
            },
          };
        });
      }, []);

      const min = React.useCallback((m: number) => {
        setValues((v) => {
          return {
            ...v,
            quantity: {
              ...v.quantity,
              value: m,
            },
          };
        });
      }, []);
      const [afColisage, setAfColisage] = React.useState<number>(
        Number(fArtfournis.afColisage)
      );
      const [afQtemini, setAfQtemini] = React.useState<number>(
        Number(fArtfournis.afQtemini)
      );

      useImperativeHandle(ref, () => ({
        setQuantity(newQ: number) {
          setValues((v) => {
            v.quantity.value = newQ.toString();
            v.quantity.error = "";
            return { ...v };
          });
        },
        getValue() {
          return {
            quantity: Number(values.quantity.value),
          };
        },
      }));

      useEffect(() => {
        updateNewTerme();
      }, [values.quantity.value]); // eslint-disable-line react-hooks/exhaustive-deps

      let diffColisage = 0;
      let diffQtemini = 0;
      if (afColisage > 0) {
        diffColisage =
          Math.ceil(values.quantity.value / afColisage) * afColisage;
      }
      if (afQtemini > 0 && values.quantity.value < afQtemini) {
        diffQtemini = afQtemini;
      }

      // @ts-ignore
      const arRefs = (fArtfournis.fArticle ?? "").split("/");
      const arRef = arRefs[arRefs.length - 1];
      const ctNums = (fArtfournis.ctNum ?? "").split("/");
      const ctNum = ctNums[ctNums.length - 1];
      return (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              ...((editQec || editColisage) && {
                flexWrap: "wrap",
              }),
            }}
          >
            {editColisage ? (
              <UpdateFArtfounissPropComponent
                prop={"afColisage"}
                value={afColisage}
                setEdit={setEditColisage}
                arRef={arRef}
                ctNum={ctNum}
                setValue={setAfColisage}
              />
            ) : (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip title={t("word.colisage")}>
                  <IconButton onClick={() => modulo(afColisage)}>
                    <Badge
                      color="error"
                      badgeContent={
                        Number(values.quantity.value) !== diffColisage
                          ? diffColisage
                          : 0
                      }
                    >
                      {afColisage}
                    </Badge>
                  </IconButton>
                </Tooltip>
                <IconButton size="small" onClick={() => setEditColisage(true)}>
                  <EditIcon />
                </IconButton>
              </Box>
            )}
            {editQec ? (
              <UpdateFArtfounissPropComponent
                prop={"afQtemini"}
                value={afQtemini}
                setEdit={setEditQec}
                arRef={arRef}
                ctNum={ctNum}
                setValue={setAfQtemini}
              />
            ) : (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="QEC">
                  <IconButton onClick={() => min(afQtemini)}>
                    <Badge color="error" badgeContent={diffQtemini}>
                      {afQtemini}
                    </Badge>
                  </IconButton>
                </Tooltip>
                <IconButton size="small" onClick={() => setEditQec(true)}>
                  <EditIcon />
                </IconButton>
              </Box>
            )}
          </Box>
          <TextField
            autoComplete="off"
            error={!!values.quantity.error}
            helperText={t(values.quantity.error ?? "")}
            sx={{ width: "100px" }}
            type="number"
            value={values.quantity.value}
            onChange={handleChange("quantity")}
            label={t("field.quantity")}
            onFocus={(e) => e.target.select()}
          />
        </>
      );
    }
  )
);

interface FArticleToShowFArtfournissInterface {
  fArtfourniss: FArtfournissFArticleInterface;
  ref: any;
}

const ReapproSingleArticleFournisseurComponent = React.memo(
  React.forwardRef(
    (
      {
        fArticle,
        fArtfournis,
        showFournisseur,
        switchShowFournisseur,
        odd,
        indexFArtfourniss,
        updateNewTerme,
        nbFournisseurInStock,
        setParentFArtfourniss,
      }: State3,
      ref
    ) => {
      const { t, i18n } = useTranslation();
      const theme = useTheme();
      const quantityRef: any = useRef();
      const token = useAppSelector(
        (state: RootState) => state.globalState.token
      );
      const fournisseurs = useAppSelector(
        (state: RootState) => state.globalState.fournisseurs
      );

      const getFArtfourniss = React.useCallback(() => {
        return (
          fArticle.fArtfourniss?.map((f) => {
            return {
              fArtfourniss: f,
              ref: React.createRef(),
            };
          }) ?? []
        );
      }, [fArticle.fArtfourniss]);

      const [loading, setLoading] = React.useState<boolean>(false);

      const [fArtfourniss, setFArtfourniss] = React.useState<
        FArticleToShowFArtfournissInterface[]
      >(getFArtfourniss());
      const [fArtstock, setFArtstock] = React.useState<
        FArtstockInterface | undefined
      >(fArticle.fArtstocks.find((f) => f.fDepot.deNo === DEFAULT_DEPOT));

      const [nbFournisseur, setNbFournisseur] = React.useState<number>(
        fArtfourniss.length ?? 0
      );

      const [terme, setTerme] = React.useState<number>(
        Number(fArtstock?.asQtesto) +
          Number(fArtstock?.asQtecom) -
          Number(fArtstock?.asQteres) -
          Number(fArtstock?.asQteprepa)
      );
      const applyType = React.useCallback(
        (type: string) => {
          for (const fArtfournis of fArtfourniss) {
            if (!quantityRef?.current) {
              continue;
            }
            let value = 0;
            if (fArtfournis.fArtfourniss.afPrincipal) {
              if (type === "terme" && terme < 0) {
                value = -terme;
              }
              if (type === "min") {
                value = Number(fArtstock?.asQtemini) - terme;
              }
              if (type === "max") {
                value = Number(fArtstock?.asQtemaxi) - terme;
              }
            }
            quantityRef.current.setQuantity(value);
          }
        },
        [fArtfourniss, fArtstock?.asQtemaxi, fArtstock?.asQtemini, terme]
      );

      useImperativeHandle(ref, () => ({
        applyType(type: string) {
          applyType(type);
        },
        setQuantity(newQ: number) {
          quantityRef.current.setQuantity(newQ);
        },
        getValue() {
          return {
            ctNum: fArtfournis.fArtfourniss.ctNum.replace(
              "/api/f_comptets/",
              ""
            ),
            ...quantityRef.current.getValue(),
          };
        },
      }));

      const thisFournisseur = fournisseurs?.find(
        (f) =>
          f.userIdentifier ===
          fArtfournis.fArtfourniss.ctNum.replace("/api/f_comptets/", "")
      );
      const urlFournisseur = getUrlsFournisseur(
        fArtfournis.fArtfourniss,
        thisFournisseur,
        fArticle
      );

      const changeMainFournisseur = React.useCallback(
        async (ctNum: string) => {
          setLoading(true);
          const response = await requestApi({
            method: POST,
            path:
              FARTICLE_URL +
              "/" +
              fArticle.arRef +
              "/main-fournisseur/" +
              ctNum,
            allowError: true,
            token: token,
            body: {},
          });
          if (response.statusCode === 200) {
            setParentFArtfourniss(
              (x: FArticleToShowFArtfournissInterface[]) => {
                for (const fArtfournis of x) {
                  if (
                    fArtfournis.fArtfourniss.fArticle
                      ?.toString()
                      .replace("/api/f_articles/", "") === fArticle.arRef
                  ) {
                    fArtfournis.fArtfourniss.afPrincipal =
                      fArtfournis.fArtfourniss.ctNum.includes(ctNum) ? 1 : 0;
                  }
                }
                return [...x];
              }
            );
          } else {
            for (let message of getErrorApi(response.content)) {
              toastr.error(t("word.error"), t(message));
            }
          }
          setLoading(false);
        },
        [fArticle.arRef, setParentFArtfourniss, t, token]
      );

      return (
        <>
          <StyledTableRow
            key={fArtfournis.fArtfourniss.ctNum}
            sx={{
              ...(odd && {
                backgroundColor: "rgba(0,0,0,0.2)",
              }),
              ...(showFournisseur &&
                fArtfournis.fArtfourniss.ctNum.includes(SUPPLIER_MC3) && {
                  backgroundColor: theme.palette.info.main,
                }),
            }}
          >
            <StyledTableCell
              sx={{
                borderLeft:
                  "1px solid " + theme.palette.primary.main + " !important",
                ...(!showFournisseur &&
                  fArtfournis.fArtfourniss.afPrincipal && {
                    fontWeight: "bold",
                    color: theme.palette.primary.main,
                  }),
              }}
            >
              {showFournisseur && (
                <Checkbox
                  checked={fArtfournis.fArtfourniss.afPrincipal === 1}
                  disabled={loading}
                  onChange={() => {
                    if (fArtfournis.fArtfourniss.afPrincipal !== 1) {
                      changeMainFournisseur(
                        fArtfournis.fArtfourniss.ctNum.replace(
                          "/api/f_comptets/",
                          ""
                        )
                      );
                    }
                  }}
                />
              )}
              <Tooltip title={thisFournisseur?.ctIntitule ?? ""}>
                <Typography component="span">
                  {fArtfournis.fArtfourniss.ctNum.replace(
                    "/api/f_comptets/",
                    ""
                  )}
                </Typography>
              </Tooltip>
            </StyledTableCell>
            <StyledTableCell>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                {urlFournisseur.arCodebarre && (
                  <Tooltip title={t("word.barCode")} placement="top">
                    <LinkReact
                      href={urlFournisseur.arCodebarre}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <IconButton>
                        <QrCodeScannerIcon />
                      </IconButton>
                    </LinkReact>
                  </Tooltip>
                )}
                {urlFournisseur.afReffourniss && (
                  <Tooltip title={t("word.supplier")} placement="top">
                    <LinkReact
                      href={urlFournisseur.afReffourniss}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <IconButton>
                        <LinkIcon />
                      </IconButton>
                    </LinkReact>
                  </Tooltip>
                )}
                {urlFournisseur.constructeurRef && (
                  <Tooltip title={t("word.constructor")} placement="top">
                    <LinkReact
                      href={urlFournisseur.constructeurRef}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <IconButton>
                        <FactoryIcon />
                      </IconButton>
                    </LinkReact>
                  </Tooltip>
                )}
              </Box>
              <CopyClipboardComponent
                className="RobotoMono"
                sx={{
                  paddingInline: 1,
                  wordBreak: "keep-all",
                  textAlign: "center",
                }}
                text={fArtfournis.fArtfourniss.afReffourniss}
              />
            </StyledTableCell>
            <StyledTableCell>
              <Box sx={{ display: "flex" }}>
                <FArticleFournisseurStockComponent
                  fArtfournis={fArtfournis.fArtfourniss}
                  small={true}
                />
              </Box>
            </StyledTableCell>
            <StyledTableCell>
              <Typography
                sx={{
                  ...(Number(fArtfournis.fArtfourniss.afPrixach) !==
                    Number(fArticle.arPunet ?? 0) &&
                    Number(fArticle.arPunet ?? 0) > 0 && {
                      color:
                        Number(fArtfournis.fArtfourniss.afPrixach) >
                        Number(fArticle.arPunet ?? 0)
                          ? "red"
                          : "green",
                    }),
                }}
              >
                {priceFormat(
                  Number(fArtfournis.fArtfourniss.afPrixach) * 100,
                  i18n.language,
                  "EUR"
                )}
              </Typography>
              <Tooltip title="Dernier prix d'achat">
                <Typography>
                  {priceFormat(
                    Number(fArticle.arPunet ?? 0) * 100,
                    i18n.language,
                    "EUR"
                  )}
                </Typography>
              </Tooltip>
            </StyledTableCell>
            <StyledTableCell>
              {indexFArtfourniss === 0 && nbFournisseur > 1 && (
                <IconButton
                  color="inherit"
                  size="small"
                  onClick={() => {
                    switchShowFournisseur();
                  }}
                >
                  {showFournisseur ? (
                    <ExpandLessIcon fontSize="inherit" />
                  ) : (
                    <Badge color="success" badgeContent={nbFournisseurInStock}>
                      <ExpandMoreIcon fontSize="inherit" />
                    </Badge>
                  )}
                </IconButton>
              )}
            </StyledTableCell>
            <StyledTableCell>
              <ReapproSingleArticleInputComponent
                initQuantity={0}
                ref={quantityRef}
                updateNewTerme={updateNewTerme}
                fArtfournis={fArtfournis.fArtfourniss}
              />
            </StyledTableCell>
          </StyledTableRow>
        </>
      );
    }
  )
);

const ReapproSingleArticleComponent = React.memo(
  React.forwardRef(({ fArticle, odd, index, last }: State, ref) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [showFournisseur, setShowFournisseur] =
      React.useState<boolean>(false);
    const getFArtfourniss =
      React.useCallback((): FArticleToShowFArtfournissInterface[] => {
        return (
          fArticle.fArtfourniss?.map(
            (f): FArticleToShowFArtfournissInterface => {
              return {
                fArtfourniss: f,
                ref: React.createRef(),
              };
            }
          ) ?? []
        )?.filter((fArtfournis) => {
          if (!showFournisseur) {
            return fArtfournis.fArtfourniss.afPrincipal === 1;
          }
          return true;
        });
      }, [fArticle.fArtfourniss, showFournisseur]);

    const [fArtfourniss, setFArtfourniss] = React.useState<
      FArticleToShowFArtfournissInterface[]
    >(getFArtfourniss());
    const [fArtstock, setFArtstock] = React.useState<
      FArtstockInterface | undefined
    >(fArticle.fArtstocks.find((f) => f.fDepot.deNo === DEFAULT_DEPOT));
    const [nbFournisseurInStock, setNbFournisseurInStock] =
      React.useState<number>(() => {
        return (
          fArticle.fArtfourniss?.filter(
            (f) =>
              f.fArtfournissProp?.stockStatus ===
              FOURNISSEUR_STOCK_STATUS_IN_STOCK
          ).length ?? 0
        );
      });

    const [terme, setTerme] = React.useState<number>(
      Number(fArtstock?.asQtesto) +
        Number(fArtstock?.asQtecom) -
        Number(fArtstock?.asQteres) -
        Number(fArtstock?.asQteprepa)
    );
    const getNewTerme = React.useCallback(() => {
      let sumQuantity = 0;
      for (const fArtfournis of fArtfourniss) {
        if (!fArtfournis.ref?.current) {
          continue;
        }
        sumQuantity += Number(fArtfournis.ref.current.getValue().quantity);
      }
      return terme + sumQuantity;
    }, [fArtfourniss, terme]);
    const [newTerme, setNewTerme] = React.useState<number>(getNewTerme());
    const updateNewTerme = React.useCallback(() => {
      setNewTerme(getNewTerme());
    }, [getNewTerme]);

    const applyType = React.useCallback(
      (type: string) => {
        for (const fArtfournis of fArtfourniss) {
          if (!fArtfournis.ref?.current) {
            continue;
          }
          let value = 0;
          if (fArtfournis.fArtfourniss.afPrincipal) {
            if (type === "terme" && terme < 0) {
              value = -terme;
            }
            if (type === "min") {
              value = Number(fArtstock?.asQtemini) - terme;
            }
            if (type === "max") {
              value = Number(fArtstock?.asQtemaxi) - terme;
            }
          }
          fArtfournis.ref.current.setQuantity(value);
        }
      },
      [fArtfourniss, fArtstock?.asQtemaxi, fArtstock?.asQtemini, terme]
    );

    const switchShowFournisseur = React.useCallback(() => {
      const newValue = !showFournisseur;
      if (!newValue) {
        setFArtfourniss((x) => {
          return x.filter((fArtfournis) => {
            return (
              fArtfournis.fArtfourniss.afPrincipal === 1 ||
              fArtfournis.ref.current.getValue().quantity > 0
            );
          });
        });
      }
      setShowFournisseur(newValue);
    }, [showFournisseur]);

    useImperativeHandle(ref, () => ({
      applyType(type: string) {
        applyType(type);
      },
      getValue() {
        return fArtfourniss.map((f) => {
          return {
            arRef: f.fArtfourniss.fArticle
              ?.toString()
              .replace("/api/f_articles/", ""),
            ...f.ref.current.getValue(),
          };
        });
      },
    }));

    React.useEffect(() => {
      if (!showFournisseur) {
        updateNewTerme();
      } else {
        setFArtfourniss(getFArtfourniss());
      }
    }, [showFournisseur]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        <StyledTableRow
          sx={{
            ...(index > 0 && {
              borderBottom: "10px solid " + theme.palette.primary.main,
            }),
            ...(odd && {
              backgroundColor: "rgba(0,0,0,0.2)",
            }),
          }}
        >
          <StyledTableCell
            rowSpan={fArtfourniss.length + 1}
            sx={{
              ...(!last && {
                borderBottom: "10px solid " + theme.palette.primary.main,
              }),
            }}
          >
            {index + 1}
          </StyledTableCell>
          <StyledTableCell
            sx={{
              ...(!last && {
                borderBottom: "10px solid " + theme.palette.primary.main,
              }),
            }}
            rowSpan={fArtfourniss.length + 1}
          >
            <Link
              style={{ textDecoration: "none", color: "inherit" }}
              to={PRODUCT_PAGE + "/" + fArticle.fArticleProp?.slug}
              state={fArticle}
              target="_blank"
            >
              {fArticle.fArticleProp?.images && (
                <img
                  src={
                    (process.env.REACT_APP_API_URL ?? "") +
                    getUrlFArticleImage(
                      fArticle.arRef,
                      fArticle.fArticleProp?.images[0],
                      IMAGE_SIZE_LOGO
                    )
                  }
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    margin: "auto",
                    minWidth: "50px",
                  }}
                  alt={"[" + fArticle.arRef + "] " + fArticle.arDesign}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
              )}
            </Link>
          </StyledTableCell>
          <StyledTableCell
            sx={{
              ...(!last && {
                borderBottom: "10px solid " + theme.palette.primary.main,
              }),
            }}
            rowSpan={fArtfourniss.length + 1}
          >
            <CopyClipboardComponent
              className="RobotoMono"
              sx={{
                paddingInline: 1,
                fontWeight: "bold",
                wordBreak: "keep-all",
                textAlign: "center",
                color: theme.palette.success.main,
              }}
              text={fArticle.arRef}
            />
          </StyledTableCell>
          <StyledTableCell
            sx={{
              ...(!last && {
                borderBottom: "10px solid " + theme.palette.primary.main,
              }),
            }}
            rowSpan={fArtfourniss.length + 1}
          >
            <Typography>{fArticle.arDesign}</Typography>
            <Accordion defaultExpanded={false}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                sx={{ backgroundColor: theme.palette.primary.main }}
              >
                <Typography sx={{ color: "white" }}>
                  {t("word.seeData")}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ChartComponent fArticle={fArticle} />
              </AccordionDetails>
            </Accordion>
          </StyledTableCell>
          <StyledTableCell
            sx={{
              ...(!last && {
                borderBottom: "10px solid " + theme.palette.primary.main,
              }),
            }}
            rowSpan={fArtfourniss.length + 1}
          >
            <Box sx={{ display: "flex" }}>
              <Box>
                <Tooltip
                  placement="left"
                  title={
                    <table>
                      <thead>
                        <tr>
                          <td>{t("word.quantityStock")}</td>
                          <td>{t("word.quantityOrdered")}</td>
                          <td>{t("word.quantityReserved")}</td>
                          <td>{t("word.quantityPrepared")}</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{Number(fArtstock?.asQtesto)}</td>
                          <td>{Number(fArtstock?.asQtecom)}</td>
                          <td>{Number(fArtstock?.asQteres)}</td>
                          <td>{Number(fArtstock?.asQteprepa)}</td>
                        </tr>
                      </tbody>
                    </table>
                  }
                >
                  <Box
                    sx={{
                      ...(terme < 0 && {
                        color: "red",
                      }),
                    }}
                  >
                    <IconButton onClick={() => applyType("terme")}>
                      {terme}
                    </IconButton>
                  </Box>
                </Tooltip>
              </Box>
              <Box>
                {fArticle.achats?.map((achat, indexAchat) => (
                  <Box key={indexAchat}>
                    {Number(achat.dlQte) +
                      " " +
                      achat.fDocentete.doPiece +
                      " [" +
                      achat.ctNum +
                      "]"}
                  </Box>
                ))}
              </Box>
            </Box>
          </StyledTableCell>
          <StyledTableCell
            rowSpan={fArtfourniss.length + 1}
            sx={{
              ...(!last && {
                borderBottom: "10px solid " + theme.palette.primary.main,
              }),
              ...(newTerme !== terme && {
                backgroundColor: theme.palette.info.main,
              }),
            }}
          >
            <Box
              sx={{
                ...(newTerme < 0 && {
                  color: "red",
                }),
              }}
            >
              {newTerme}
            </Box>
          </StyledTableCell>
          <StyledTableCell
            sx={{
              ...(!last && {
                borderBottom: "10px solid " + theme.palette.primary.main,
              }),
            }}
            rowSpan={fArtfourniss.length + 1}
          >
            <IconButton onClick={() => applyType("min")}>
              {Number(fArtstock?.asQtemini)}
            </IconButton>
          </StyledTableCell>
          <StyledTableCell
            sx={{
              ...(!last && {
                borderBottom: "10px solid " + theme.palette.primary.main,
              }),
            }}
            rowSpan={fArtfourniss.length + 1}
          >
            <IconButton onClick={() => applyType("max")}>
              {Number(fArtstock?.asQtemaxi)}
            </IconButton>
          </StyledTableCell>
        </StyledTableRow>
        {fArtfourniss
          ?.sort(
            (a, b) =>
              Number(a.fArtfourniss.afPrixach) -
              Number(b.fArtfourniss.afPrixach)
          )
          ?.map((fArtfournis, indexFArtfourniss) => (
            <ReapproSingleArticleFournisseurComponent
              fArticle={fArticle}
              key={(
                (fArtfournis.fArtfourniss.fArticle ?? "") +
                "@@@" +
                fArtfournis.fArtfourniss.ctNum
              ).toString()}
              fArtfournis={fArtfournis}
              showFournisseur={showFournisseur}
              odd={odd}
              indexFArtfourniss={indexFArtfourniss}
              switchShowFournisseur={switchShowFournisseur}
              updateNewTerme={updateNewTerme}
              ref={fArtfournis.ref}
              nbFournisseurInStock={nbFournisseurInStock}
              setParentFArtfourniss={setFArtfourniss}
            />
          ))}
      </>
    );
  })
);

const ReapproFournisseurDocumentComponent = React.memo(
  React.forwardRef(({ willCreate, index }: State4, ref) => {
    const { t } = useTranslation();
    const getDefaultValue = React.useCallback((): FormState3 => {
      return {
        reference: {
          value: "REAPPRO",
          error: "",
        },
      };
    }, []);
    const [values, setValues] = React.useState<FormState3>(getDefaultValue());
    const [running, setRunning] = React.useState<boolean>(false);
    const [doPiece, setDoPiece] = React.useState<string | null>("");

    const handleChange = React.useCallback(
      (prop: keyof FormState3) =>
        (event: React.ChangeEvent<HTMLInputElement>) => {
          setValues((v) => {
            return {
              ...v,
              [prop]: { ...v[prop], value: event.target.value, error: "" },
            };
          });
        },
      []
    );

    useImperativeHandle(ref, () => ({
      setRunning(v: boolean) {
        setRunning(v);
      },
      getValue() {
        return {
          reference: values.reference.value,
        };
      },
      setDoPiece(doPiece: string | null) {
        setDoPiece(doPiece);
      },
    }));

    return (
      <>
        <TableRow>
          <TableCell>{willCreate.ctNum}</TableCell>
          <TableCell>{willCreate.nbFArticle}</TableCell>
          <TableCell>
            <TextField
              autoComplete="off"
              error={!!values.reference.error}
              helperText={t(values.reference.error ?? "")}
              sx={{ width: "100%" }}
              type="text"
              value={values.reference.value}
              onChange={handleChange("reference")}
              label={t("word.reference")}
            />
          </TableCell>
          <TableCell>
            {doPiece ? (
              doPiece
            ) : (
              <>
                {doPiece === null ? (
                  <>
                    <CloseIcon color="error" />
                  </>
                ) : (
                  <>
                    {running && (
                      <Box sx={{ textAlign: "center" }}>
                        <CircularProgress />
                      </Box>
                    )}
                  </>
                )}
              </>
            )}
          </TableCell>
        </TableRow>
      </>
    );
  })
);

const ReapproArticlesComponent: React.FC = React.memo(() => {
  const token = useAppSelector((state: RootState) => state.globalState.token);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [maxWidth] = React.useState<DialogProps["maxWidth"]>("md");
  const [loadingRefresh, setLoadingRefresh] = React.useState(false);
  const [fArticles, setFArticles] = React.useState<
    FArticleSmallInterface[] | undefined
  >(undefined);
  const refreshPage = useAppSelector(
    (state: RootState) => state.globalState.refreshPage
  );
  const [init, setInit] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const getDefaultValue = React.useCallback((): FormState2 => {
    return {
      showOnlyTerme: {
        value: false,
        error: "",
      },
      fournisseur: {
        value: "",
        error: "",
      },
      fournisseurOrAnd: {
        value: CONDITION_OR,
        error: "",
      },
      fournisseurPrincipal: {
        value: "",
        error: "",
      },
    };
  }, []);
  const [values, setValues] = React.useState<FormState2>(getDefaultValue());
  const [fournisseurs, setFournisseurs] = React.useState<string[]>([]);
  const [mainFournisseurs, setMainFournisseurs] = React.useState<string[]>([]);
  const [done, setDone] = React.useState(false);

  const getFArticlesToShow = React.useCallback(() => {
    const result =
      fArticles?.filter((f) => {
        let result = true;
        if (values.showOnlyTerme.value) {
          const fArtstock = f.fArtstocks.find(
            (y) => y.fDepot.deNo === DEFAULT_DEPOT
          );
          const terme =
            Number(fArtstock?.asQtesto) +
            Number(fArtstock?.asQtecom) -
            Number(fArtstock?.asQteres) -
            Number(fArtstock?.asQteprepa);
          result &&= terme < 0;
        }
        const fournisseurPrincipal = f.fArtfourniss?.find(
          (f) =>
            f.ctNum.replace("/api/f_comptets/", "") ===
              values.fournisseurPrincipal.value && f.afPrincipal === 1
        );
        const fournisseur = f.fArtfourniss?.find(
          (f) =>
            f.ctNum.replace("/api/f_comptets/", "") === values.fournisseur.value
        );
        if (
          values.fournisseurPrincipal.value !== "" &&
          values.fournisseur.value !== ""
        ) {
          if (values.fournisseurOrAnd.value === CONDITION_AND) {
            result &&= !!fournisseurPrincipal && !!fournisseur;
          } else {
            result &&= !!fournisseurPrincipal || !!fournisseur;
          }
        } else {
          if (values.fournisseurPrincipal.value !== "") {
            result &&= !!fournisseurPrincipal;
          }
          if (values.fournisseur.value !== "") {
            result &&= !!fournisseur;
          }
        }
        return result;
      }) ?? [];
    result.sort((a, b) => a.arRef.localeCompare(b.arRef));
    return result.map((f) => {
      return {
        fArticle: f,
        ref: React.createRef(),
      };
    });
  }, [
    fArticles,
    values.fournisseur.value,
    values.fournisseurOrAnd,
    values.fournisseurPrincipal.value,
    values.showOnlyTerme.value,
  ]);
  const [createdFDocentetes, setCreatedFDocentetes] = React.useState<string[]>(
    []
  );

  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const [willCreate, setWillCreate] = React.useState<WillCreateInterface[]>([]);
  const [fArticlesToShow, setFArticlesToShow] = React.useState<
    FArticleToShowInterface[]
  >(getFArticlesToShow());

  const handleCloseDialog = React.useCallback(() => {
    if (loading) {
      return;
    }
    setWillCreate([]);
    setOpenDialog(false);
  }, [loading]);

  const handleOpenDialog = React.useCallback(() => {
    const result: WillCreateInterface[] = [];
    const body = fArticlesToShow.flatMap((f) => f.ref.current.getValue());
    for (const data of body) {
      let item = result.find((x) => x.ctNum === data.ctNum);
      if (!item) {
        item = {
          ctNum: data.ctNum,
          nbFArticle: 0,
          ref: React.createRef(),
        };
        result.push(item);
      }
      item.nbFArticle += data.quantity;
    }
    setWillCreate(result.filter((x) => x.nbFArticle > 0));
    setDone(false);
    setOpenDialog(true);
  }, [fArticlesToShow]);

  const load = React.useCallback(
    async (force: boolean = false, refresh: boolean = false) => {
      setInit(true);
      if (fArticles !== undefined && !refresh && !force) {
        dispatch(set({ refreshPage: false }));
        return;
      }
      setFArticles(undefined);
      let url = FARTICLE_URL + "-reapro";
      if (refresh) {
        url += "-refresh";
        setLoadingRefresh(true);
      }
      const response = await requestApi({
        method: GET,
        path: url,
        allowError: false,
        token: token,
        timeout: 60_000 * 5,
      });
      if (response.statusCode === 200) {
        setFArticles(response.content);
        let newFournisseurs = [];
        let newMainFournisseurs = [];
        for (const fArticle of response.content) {
          for (const fArtfournis of fArticle.fArtfourniss) {
            const ctNum = fArtfournis.ctNum.replace("/api/f_comptets/", "");
            newFournisseurs.push(ctNum);
            if (fArtfournis.afPrincipal) {
              newMainFournisseurs.push(ctNum);
            }
          }
        }
        // @ts-ignore
        newFournisseurs = [...new Set(newFournisseurs)];
        // @ts-ignore
        newMainFournisseurs = [...new Set(newMainFournisseurs)];
        newFournisseurs.sort();
        newMainFournisseurs.sort();
        setFournisseurs(newFournisseurs);
        setMainFournisseurs(newMainFournisseurs);
      } else {
        setFArticles([]);
        if (response.statusCode === 401) {
          toastr.info(t("word.info"), t("error.reconnect"));
        } else {
          toastr.error(t("word.error"), t("error.tryAgain"));
        }
      }
      if (refresh) {
        setLoadingRefresh(false);
      }
      dispatch(set({ refreshPage: false }));
    },
    [dispatch, fArticles, t, token]
  );

  const applyType = React.useCallback(
    (type: string) => {
      for (const fArticleToShow of fArticlesToShow) {
        if (!fArticleToShow.ref?.current) {
          continue;
        }
        fArticleToShow.ref.current.applyType(type);
      }
    },
    [fArticlesToShow]
  );

  const createFDocenteteAchat = React.useCallback(async () => {
    const data = fArticlesToShow.flatMap((f) => f.ref.current.getValue());
    const bodyByCtNum: any[] = Object.values(
      data.reduce((acc, item) => {
        if (!acc[item.ctNum]) {
          acc[item.ctNum] = [];
        }
        acc[item.ctNum].push(item);
        return acc;
      }, {})
    );
    setLoading(true);
    for (let body of bodyByCtNum) {
      const thisWillCreate = willCreate.find((x) => x.ctNum === body[0].ctNum);
      const moreData: any = thisWillCreate?.ref.current.getValue() ?? {};
      thisWillCreate?.ref.current.setRunning(true);
      body = body.map((x: any) => {
        return {
          ...x,
          ...moreData,
        };
      });
      const response = await requestApi({
        method: POST,
        path: FDOCENTETES_URL + "/reappro",
        allowError: true,
        token: token,
        body: body,
        timeout: 300_000, // 5min
      });
      if (response.statusCode === 200) {
        if (response.content.length > 0) {
          const doPiece = response.content[0].doPiece;
          thisWillCreate?.ref.current.setDoPiece(doPiece);
        } else {
          thisWillCreate?.ref.current.setDoPiece(null);
        }
      } else if (response.statusCode === 401) {
        toastr.info(t("word.info"), t("error.reconnect"));
      } else {
        for (let message of getErrorApi(response.content)) {
          toastr.error(t("word.error"), t(message));
        }
      }
    }
    setLoading(false);
    setDone(true);
  }, [fArticlesToShow, t, token, willCreate]);

  const handleChangeCheckbox = React.useCallback(
    (prop: keyof FormState2) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues((v) => {
        return {
          ...v,
          [prop]: { ...v[prop], value: event.target.checked, error: "" },
        };
      });
    },
    []
  );

  const handleChangeSelect = React.useCallback(
    (prop: keyof FormState2) => (event: SelectChangeEvent) => {
      setValues((v) => {
        return {
          ...v,
          [prop]: {
            ...v[prop],
            value: event.target.value as string,
            error: "",
          },
        };
      });
    },
    []
  );

  React.useEffect(() => {
    load();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (init && refreshPage) {
      load(true);
    }
  }, [refreshPage]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    setFArticlesToShow(getFArticlesToShow());
  }, [
    fArticles,
    values.showOnlyTerme.value,
    values.fournisseur.value,
    values.fournisseurPrincipal.value,
    values.fournisseurOrAnd.value,
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <Dialog maxWidth={maxWidth} onClose={handleCloseDialog} open={openDialog}>
        <DialogContent>
          <Typography>{t("sentence.beforeCreatedFDocentete")}</Typography>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{t("word.supplier")}</TableCell>
                  <TableCell>{t("field.nbFArticle")}</TableCell>
                  <TableCell>{t("word.reference")}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {willCreate.map((x, index) => (
                  <ReapproFournisseurDocumentComponent
                    willCreate={x}
                    index={index}
                    key={index}
                    ref={x.ref}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        {done ? (
          <DialogActions sx={{ justifyContent: "space-between" }}>
            <Box></Box>
            <LoadingButton disabled={loading} onClick={handleCloseDialog}>
              {t("word.close")}
            </LoadingButton>
          </DialogActions>
        ) : (
          <DialogActions sx={{ justifyContent: "space-between" }}>
            <LoadingButton disabled={loading} onClick={handleCloseDialog}>
              {t("word.no")}
            </LoadingButton>
            <LoadingButton
              variant="contained"
              onClick={createFDocenteteAchat}
              loading={loading}
            >
              {t("word.yes")}
            </LoadingButton>
          </DialogActions>
        )}
      </Dialog>
      {fArticles === undefined ? (
        <SearchComponent nbColumn={1} nbLines={1} />
      ) : (
        <>
          <Box sx={{ display: "flex" }}>
            <LoadingButton
              variant="contained"
              loading={loadingRefresh}
              onClick={() => {
                load(false, true);
              }}
            >
              {t("word.refresh")}
            </LoadingButton>
            <FormControlLabel
              sx={{ marginLeft: 2 }}
              control={
                <Checkbox
                  checked={values.showOnlyTerme.value}
                  onChange={handleChangeCheckbox("showOnlyTerme")}
                />
              }
              label={t("sentence.showOnlyTerme")}
            />
          </Box>
          <Box sx={{ display: "flex" }}>
            <FormControl fullWidth>
              <InputLabel id="fournisseur-principal">
                {t("word.mainSupplier")}
              </InputLabel>
              <Select
                labelId="fournisseur-principal"
                value={values.fournisseurPrincipal.value}
                label={t("word.mainSupplier")}
                onChange={handleChangeSelect("fournisseurPrincipal")}
              >
                <MenuItem value="">
                  <em>{t("word.all")}</em>
                </MenuItem>
                {mainFournisseurs.map((fournisseur, indexFournisseur) => (
                  <MenuItem value={fournisseur} key={indexFournisseur}>
                    {fournisseur}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth required>
              <InputLabel id={"condition-filter"}>
                {t("field.condition")}
              </InputLabel>
              <Select
                labelId={"condition-filter"}
                value={values.fournisseurOrAnd.value}
                label={t("field.condition")}
                onChange={handleChangeSelect("fournisseurOrAnd")}
              >
                {CONDITIONS_FILTER.map((condition, indexType) => (
                  <MenuItem value={condition} key={indexType}>
                    {t("word.filter.condition." + condition)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="fournisseur">{t("word.supplier")}</InputLabel>
              <Select
                labelId="fournisseur"
                value={values.fournisseur.value}
                label={t("word.supplier")}
                onChange={handleChangeSelect("fournisseur")}
              >
                <MenuItem value="">
                  <em>{t("word.all")}</em>
                </MenuItem>
                {fournisseurs.map((fournisseur, indexFournisseur) => (
                  <MenuItem value={fournisseur} key={indexFournisseur}>
                    {fournisseur}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <TableContainer component={Paper}>
            <Table size="small" sx={{ width: "100%", overflow: "auto" }}>
              <TableHead>
                <TableRow>
                  {/*@ts-ignore*/}
                  {[...Array(4).keys()].map((i) => (
                    <StyledTableCell key={i}></StyledTableCell>
                  ))}
                  <StyledTableCell>
                    <IconButton onClick={() => applyType("terme")}>
                      terme
                    </IconButton>
                  </StyledTableCell>
                  <StyledTableCell>Nterme</StyledTableCell>
                  <StyledTableCell>
                    <IconButton onClick={() => applyType("min")}>
                      min
                    </IconButton>
                  </StyledTableCell>
                  <StyledTableCell>
                    <IconButton onClick={() => applyType("max")}>
                      max
                    </IconButton>
                  </StyledTableCell>
                  {/*@ts-ignore*/}
                  {[...Array(6).keys()].map((i) => (
                    <StyledTableCell key={i}></StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {fArticlesToShow.map((fArticleToShow, indexFArticleToShow) => {
                  return (
                    <ReapproSingleArticleComponent
                      fArticle={fArticleToShow.fArticle}
                      odd={indexFArticleToShow % 2 === 0}
                      key={fArticleToShow.fArticle.fArticleProp.id}
                      index={indexFArticleToShow}
                      ref={fArticleToShow.ref}
                      last={indexFArticleToShow === fArticlesToShow.length - 1}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {fArticlesToShow.length > 0 && (
            <>
              {createdFDocentetes.length > 0 && (
                <>
                  {createdFDocentetes.map((createdFDocentete) => (
                    <Alert
                      key={createdFDocentete}
                      severity="info"
                      sx={{ marginTop: 2 }}
                    >
                      {t("sentence.createdFDocentete") +
                        " " +
                        createdFDocentete}
                    </Alert>
                  ))}
                </>
              )}
              <Box sx={{ textAlign: "right", marginTop: 2 }}>
                <LoadingButton
                  variant="contained"
                  loading={loading}
                  onClick={handleOpenDialog}
                >
                  {t("word.order")}
                </LoadingButton>
              </Box>
            </>
          )}
        </>
      )}
    </Box>
  );
});

const ReapproComponent: React.FC = React.memo(() => {
  return (
    <Grid container spacing={1} sx={{ marginY: 2, paddingX: 2 }}>
      <Grid
        item
        xs={12}
        sx={{
          padding: "0!important",
        }}
      >
        <ReapproArticlesComponent />
      </Grid>
    </Grid>
  );
});

export default ReapproComponent;
